import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

interface FuelGaugeProps {
  fuelLevel: number;
  onFuelLevelChange: (level: number) => void;
}

export const FuelGauge: React.FC<FuelGaugeProps> = ({ fuelLevel, onFuelLevelChange }) => {
  const setFuelLevelFromPress = (event: any) => {
    const { locationX, width } = event.nativeEvent;
    const percentage = Math.max(0, Math.min(100, (locationX / width) * 100));
    onFuelLevelChange(percentage);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.gauge}
        onPress={setFuelLevelFromPress}
        activeOpacity={0.8}
      >
        <View style={styles.fuelBackground}>
          <View 
            style={[
              styles.fuelFill, 
              { width: `${fuelLevel}%` }
            ]} 
          />
          <View style={[styles.indicator, { left: `${fuelLevel}%` }]} />
        </View>
      </TouchableOpacity>
      
      <View style={styles.markers}>
        <Text style={styles.marker}>E</Text>
        <Text style={styles.marker}>¼</Text>
        <Text style={styles.marker}>½</Text>
        <Text style={styles.marker}>¾</Text>
        <Text style={styles.marker}>F</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
  },
  gauge: {
    width: '100%',
    height: 18,
    borderWidth: 1,
    borderColor: '#333',
    borderRadius: 2,
    overflow: 'hidden',
    position: 'relative',
  },
  fuelBackground: {
    flex: 1,
    backgroundColor: '#f0f0f0',
    position: 'relative',
  },
  fuelFill: {
    height: '100%',
    backgroundColor: '#4CAF50', // Green color for fuel
    position: 'absolute',
    left: 0,
    top: 0,
  },
  indicator: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 3,
    backgroundColor: '#333',
    marginLeft: -1.5,
  },
  markers: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 2,
    paddingHorizontal: 2,
  },
  marker: {
    fontSize: 9,
    color: '#666',
  },
});

export default FuelGauge;
